import { gql } from '@apollo/client';

export const CASE = gql`
	query Case($id: UUID) {
		case(id: $id) {
			id
			patientId
			isMeddi
		}
	}
`;
